import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './CompareBox.css'

import Heading from '../Heading'

class CompareBox extends Component {
  getNewCompareBoxObject () {
    return {title: null, content: []}
  }

  render () {
    const parts = []
    let part = this.getNewCompareBoxObject()
    let counter = 0

    const wrapperClasses = classNames({
      'hw-compare-box-wrapper': true,
      [styles.compare_box_wrapper]: true
    })
    const compareBoxClasses = classNames({
      'hw-compare-box': true,
      [styles.compare_box]: true
    })
    const compareBoxItemClasses = classNames({
      'hw-compare-box-item': true,
      [styles.compare_box_item]: true
    })
    const compareBoxTitleClasses = classNames({
      'hw-compare-box-title': true,
      [styles.compare_box_title]: true
    })
    const compareBoxContentClasses = classNames({
      'hw-compare-box-content': true,
      [styles.compare_box_content]: true
    })

    for (const child of this.props.children) {
      if (child && typeof child === 'object' && child.type !== 'h3') {
        for (const section of child.props.children) {
          if (section && typeof section === 'object') {
            if (section.props['data-element'] === 'title') {
              part.title = section.props.children[0]
            } else {
              part.content.push(section)
            }
          }
        }

        if (part.content.length !== 0) {
          parts.push(<div key={`hw-compare-box-item-key-${counter++}`} className={compareBoxItemClasses} >
            <Heading headingLevel={3} styleLevel={0} className={compareBoxTitleClasses}>{part.title}</Heading>
            <div className={compareBoxContentClasses}>{part.content}</div>
          </div>)
          part = this.getNewCompareBoxObject()
        }
      }
    }

    return (
      <fieldset className={wrapperClasses}>
        <div className={compareBoxClasses}>{parts}</div>
      </fieldset>
    )
  }
}

CompareBox.propTypes = {
  children: PropTypes.node
}

export default CompareBox



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/CompareBox/index.js